import { render, staticRenderFns } from "./CambioPrograma.vue?vue&type=template&id=9deb221a"
import script from "./CambioPrograma.vue?vue&type=script&lang=js"
export * from "./CambioPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports